module.exports = __webpack_public_path__ + "img/boltFull.c4e3aded.svg";